var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.0644531 19.8265C11.1792 18.5697 19.9886 10.5799 21.375 0.499023H21.7553C23.1416 10.5794 31.9504 18.569 43.0645 19.8264V20.1714C31.9496 21.4289 23.1403 29.4196 21.755 39.5011H21.3753C19.99 29.4191 11.18 21.4282 0.0644531 20.1713L0.0644531 19.8265Z","fill":"#C7D5D9"}));
}

StarInline.defaultProps = {"width":"44","height":"40","viewBox":"0 0 44 40","fill":"none","role":"img","aria-label":""};

module.exports = StarInline;

StarInline.default = StarInline;
